<style>

.bg{
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-image: url("/i/signup-bg-wizard.jpg");
  background-size: cover;
  color: black;
  padding: 20px;
  overflow-y: scroll;
}

.margin{
  margin-top: 50px;
}

</style>

<div class="bg">
  <div class="title-signup">What's your email?</div>
  <div class="margin">
    <ValidInput bind:value="{email}" valid="{valid}" on:changed="{check}"></ValidInput>
  </div>
  <div class="margin small">We'll send you a code to validate your email.</div>
  
  <div class="has-buttons"></div>
  
</div>

<!-- <div class="next">
  <button on:click="{next}" disabled="{nextDisabled}">Next</button>
</div> -->
<NextButton on:click="{next}" disabled="{nextDisabled}"></NextButton>

<script>

import {push, pop, replace, location, link} from 'svelte-spa-router';

import ValidInput from "../../../../components/ValidInput.svelte";
import NextButton from "../../../../components/NextButton.svelte";

import Signup from "../../../../helpers/Signup.js";
import Validate from "../../../../helpers/Validate.js";
import Normalize from "../../../../helpers/Normalize.js";


import { onMount } from "svelte";
onMount(async () => {
  try {
    Signup.verifyPersonalObject();
    Signup.load();
  } catch (e) {
    console.log("error:", e);
    
    if (e == "Must start from beginning") {
      document.location = "/";
    }
    
    return;
  }
  
  // if signup is already complete, then we push the user outta here...
  let signupComplete = Signup.getPersonalObject("signupComplete");
  if (signupComplete == true) {
    document.location = "/";
    return;
  }
  
  allowSignup = true;
  // Signup.saveToPersonalObject("email", "");
  emailSaved = Signup.getPersonalObject("emailSaved");
  email = Signup.getPersonalObject("email");
  
  if (emailSaved == true) {
    valid = true;
    nextDisabled = false;
  } else {
    check();
  }
  
});

let allowSignup = false;
let email = "";
let emailSaved = false;
let valid = false;
let nextDisabled = true;
let signupDelayHandle = null;
let lastEmail = "";

function check(e) {
  clearTimeout(signupDelayHandle);
  
  if (email == lastEmail) return;
  
  emailSaved = false;
  
  signupDelayHandle = setTimeout( async () => {
    lastEmail = email;
    try {
      Validate.allowSignup(allowSignup);
      Validate.email(email);
      await Signup.isEmailUsed(email);
      valid = true;
      nextDisabled = false;
    } catch (e) {
      valid = false;
      nextDisabled = true;
      console.log("error:", e);
    }
  }, 450);
  
}


async function next() {
  if (emailSaved == false) {
    email = Normalize.email(email);
    await Signup.saveToPersonalObject("email", email);
    await Signup.saveToPersonalObject("emailSaved", true);
    await Signup.saveEmail();
  }
  
  push("/signup/profile/personal/email-verify");
}


</script>